import React, {memo, useCallback, useState} from 'react';
import {useInterval} from '../../hooks/interval';

export const Timer = memo(function Timer() {
    const [second, setSecond] = useState(0);

    useInterval(useCallback(() => setSecond(second => second + 1), []), 1000);

    let minuteStr = Math.floor(second / 60).toString();
    let secondStr = (second % 60).toString();
    if (minuteStr.length < 2) {
        minuteStr = '0' + minuteStr;
    }

    if (secondStr.length < 2) {
        secondStr = '0' + secondStr;
    }

    const minuteAndSecondString = `${minuteStr}:${secondStr}`;

    return (
        <span className="time-counter">
            {minuteAndSecondString}
        </span>
    );
});
